import React, { useState, useEffect } from 'react';

function PresetForm({ preset, onSave, onCancel }) {
  const [name, setName] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('');
  const [isActive, setIsActive] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (preset) {
      setName(preset.name || '');
      setFirstName(preset.first_name || '');
      setLastName(preset.last_name || '');
      setPhone(preset.phone || '');
      setIsActive(preset.is_active || false);
    }
  }, [preset]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await onSave({
        name,
        firstName,
        lastName,
        phone,
        isActive
      });

      // Reset form if creating new preset
      if (!preset) {
        setName('');
        setFirstName('');
        setLastName('');
        setPhone('');
        setIsActive(false);
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to save preset');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="preset-form" onSubmit={handleSubmit}>
      <h3 style={{ marginBottom: '1rem', color: 'var(--soft-white)' }}>
        {preset ? 'Edit Preset' : 'New Preset'}
      </h3>

      {error && <div className="error-message">{error}</div>}

      <div className="form-group">
        <label className="form-label">Preset Name</label>
        <input
          type="text"
          className="form-input"
          placeholder="e.g., Personal, Work, Business"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
      </div>

      <div className="form-row">
        <div className="form-group">
          <label className="form-label">First Name</label>
          <input
            type="text"
            className="form-input"
            placeholder="John"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label className="form-label">Last Name</label>
          <input
            type="text"
            className="form-input"
            placeholder="Doe"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            required
          />
        </div>
      </div>

      <div className="form-group">
        <label className="form-label">Phone Number</label>
        <input
          type="tel"
          className="form-input"
          placeholder="+1 (555) 123-4567"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          required
        />
      </div>

      <div className="form-group">
        <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
          <input
            type="checkbox"
            checked={isActive}
            onChange={(e) => setIsActive(e.target.checked)}
            style={{ width: 'auto', cursor: 'pointer' }}
          />
          <span className="form-label" style={{ marginBottom: 0 }}>
            Set as active preset
          </span>
        </label>
        <div style={{ fontSize: '0.85rem', color: 'var(--muted-gray)', marginTop: '0.25rem', marginLeft: '1.5rem' }}>
          Your active preset will be used for your public link
        </div>
      </div>

      <div className="form-actions">
        <button type="submit" className="btn-success" disabled={loading}>
          {loading ? 'Saving...' : (preset ? 'Update Preset' : 'Create Preset')}
        </button>
        <button type="button" className="btn-cancel" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </form>
  );
}

export default PresetForm;
